<!-- UPPER SCREEN HALF -->

<mat-card class="pb-4">
    <mat-card-content>

        <div class="row no-gutters top-row">

            <!-- COLUMN 1 -->

            <div class="col-sm-8">

                <!-- COLUMN 1 -  ROW 1 -->

                <div class="row no-gutters">

                    <!-- COLUMN 1 -  ROW 1 - COLUMN 1 -->

                    <div class="col-sm-6">

                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <div class="col-12">
                                        <div class="smp-title mb-3"> {{ ParticipantTypes.CUSTOMER.trans | translate }}/{{ 'customer number' }}</div>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ customer?.trans.name | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ customer?.displayName }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ customer?.trans.address_phone | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ customer?.address_phone }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ customer?.trans.address_email | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ customer?.address_email }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.vehicle.trans.plate_number | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ summary?.vehicle.plate_number }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.vehicle.trans.vin | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ summary?.vehicle.vin }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.general.trans.legal_protection | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ getBooleanTranslation(summary?.general.legal_protection) | translate }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.general.trans.tax_deduction | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ getBooleanTranslation(summary?.general.tax_deduction) | translate }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-2">

                            </div>
                        </div>

                    </div>


                    <!-- COLUMN 1 -  ROW 1 - COLUMN 2 -->

                    <div class="col-sm-6">

                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <div class="col-12">
                                        <div class="smp-title mb-3"> {{ ParticipantTypes.ACCIDENT_OPPONENT_VEHICLE_OWNER.trans | translate }}</div>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ opponentVehicleOwner?.trans.name | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ opponentVehicleOwner?.displayName }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ opponentVehicleOwner?.trans.address_phone | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ opponentVehicleOwner?.address_phone }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ opponentVehicleOwner?.trans.address_email | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ opponentVehicleOwner?.address_email }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.vehicle.trans.plate_number | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ summary?.accident.opponent.plate_number }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.accident.opponent.trans.insurance | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ opponentInsurance?.displayName }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ '' | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ summary?.accident.opponent.insurance_number }}</span>
                                    </div>
                                </div>

                            </div>

                            <div class="col-sm-2">

                            </div>
                        </div>
                    </div>

                </div>


                <!-- COLUMN 1 -  ROW 2 -->

                <div class="row no-gutters mt-3">

                    <div class="col-sm-6">
                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <div class="col-12">
                                        <div class="smp-title mb-3"> {{ 'detailed_processing.summary.title.general' | translate }}</div>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.general.trans.claim_date | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ summary?.general.claim_datetime | drDateTime }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.general.trans.creation_date | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ summary?.general.creation_date | drDate }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.general.trans.vehicle_leased | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ getBooleanTranslation(summary?.general.vehicle_leased) | translate }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.general.trans.vehicle_financed | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ getBooleanTranslation(summary?.general.vehicle_financed) | translate }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ summary?.accident.trans.accident_abroad | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ getBooleanTranslation(summary?.accident.accident_abroad) | translate }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-2">

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <div class="row no-gutters">
                                    <div class="col-12">
                                        <div class="smp-title mb-3"> {{ ParticipantTypes.BODY_SHOP.trans | translate }}</div>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ bodyShop?.trans.name | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ bodyShop?.displayName }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ bodyShop?.trans.address_phone | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ bodyShop?.address_phone }}</span>
                                    </div>
                                </div>

                                <div class="row no-gutters">
                                    <div class="col-12 dr-flex-wrapper">
                                        <span>{{ bodyShop?.trans.address_email | translate }}</span>
                                        <span class="fill-remaining-space"></span>
                                        <span>{{ bodyShop?.address_email }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-2">

                            </div>
                        </div>
                    </div>
                </div>

            </div>



            <!-- COLUMN 2 -->
            <div class="col-sm-4">
                <div #commentsRow class="row no-gutters comments-row">
                    <div class="col-sm-10">
                        <div class="row no-gutters">
                            <div class="col-12">
                                <div class="smp-title comments-column-title mb-3"> {{ 'detailed_processing.summary.title.comments' | translate }}</div>
                            </div>
                        </div>

                        <div class="row no-gutters">
                            <div class="col-12">
                                <div class="row no-gutters">
                                    <div class="col-12 comments-column">
                                        <div *ngFor="let comment of summary?.comments" class="mb-2">
                                            <strong class="compact-comment-title">{{ comment.last_modification_date | drDateTime }} {{ comment.author }}: </strong>
                                            <span>{{ comment.comment }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-2">

                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-sm-10">
                        <button mat-icon-button
                                class="more-comments-btn"
                                *ngIf="commentsAreOverflowing"
                                (click)="viewAllComments()"
                                [disabled]="disabled">
                            <mat-icon class="dr-material-icon"
                                      [ngClass]="{ 'disabled': disabled }"
                                      matTooltip="{{ 'detailed_processing.summary.label.view_all_comments' | translate }}">more_horiz
                            </mat-icon>
                        </button>
                    </div>
                </div>

            </div>

        </div>

    </mat-card-content>
</mat-card>



<!-- LOWER SCREEN HALF ---------------------------------------------------------------------------------------------------------------------------------- -->

<mat-tab-group class="smp-tab-style mt-4 mb-4 full-width">

    <!-- CLAIM POSITION / CALCULATION  -->
    <mat-tab id="{{idPrefix}}tab.calculation" label="{{ 'detailed_processing.summary.title.calculation' | translate }}">
        <div class="row no-gutters">
            <div class="col-sm-8">
                <div class="row no-gutters">
                    <div class="col-sm-6">
                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <calculation-row [label]="summary?.result.calculation.trans.costs_repair_net_gross"
                                                 [val_1]="summary?.result.calculation.costs_repair_gross"
                                                 [val_2]="summary?.result.calculation.costs_repair_net"
                                                 [negative]="false">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.calculation.trans.reduced_market_value_assessor"
                                                 [val_1]="summary?.result.calculation.reduced_market_value_assessor"
                                                 [negative]="false">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.calculation.trans.appreciation"
                                                 [val_1]="summary?.result.calculation.appreciation"
                                                 [negative]="true"
                                                 [underline]="true">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.calculation.trans.claims_amount_net_gross"
                                                 [val_1]="summary?.result.calculation.claims_amount_gross"
                                                 [val_2]="summary?.result.calculation.claims_amount_net"
                                                 [bold]="true">
                                </calculation-row>

                                <calculation-row [label]="(summary?.result.trans.replacement_value_net_gross | translate) + taxationType"
                                                 [val_1]="summary?.result.replacement_value_gross"
                                                 [val_2]="summary?.result.replacement_value_net">
                                </calculation-row>

                                <mat-divider class="mt-3 mb-3"></mat-divider>

                                <calculation-row [label]="summary?.result.sums.trans.replacement_costs"
                                                 [val_1]="summary?.result.sums.replacement_costs"
                                                 [bold]="true">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.sums.trans.costs_repair_net_reduced_marketvalue"
                                                 [val_1]="summary?.result.sums.costs_repair_net_reduced_marketvalue">
                                </calculation-row>
                            </div>

                            <div class="col-sm-2">

                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="row no-gutters">
                            <div class="col-sm-10">
                                <calculation-row [label]="summary?.result.trans.leasing_transfer_costs"
                                                 [val_1]="summary?.result.leasing_transfer_costs"
                                                 [negative]="true">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.trans.replacement_value_gross"
                                                 [val_1]="summary?.result.replacement_value_gross"
                                                 [negative]="false"
                                                 [underline]="true">
                                </calculation-row>

                                <calculation-row [val_1]="summary?.result.sums.leasing_transfer_replacement_value"
                                                 [bold]="true"
                                                 [colored]="true">
                                </calculation-row>

                                <mat-divider class="mt-3 mb-3"></mat-divider>

                                <calculation-row [label]="summary?.result.trans.salvage_value_gross"
                                                 [val_1]="summary?.result.salvage_value_gross"
                                                 [negative]="true">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.trans.salvage_potential"
                                                 [val_1]="summary?.result.salvage_potential"
                                                 [negative]="false"
                                                 [underline]="true">
                                </calculation-row>

                                <calculation-row [val_1]="summary?.result.sums.salvage_value_potential"
                                                 [bold]="true"
                                                 [colored]="true">
                                </calculation-row>

                                <mat-divider class="mt-3 mb-3"></mat-divider>

                                <div class="row mt-2 mb-2">
                                    <div class="col-sm-12 sub-total-1"
                                         align="center"
                                         [ngClass]="{ 'iq-color-2': summary?.result.sums.subtotal1 >= 0, 'iq-color-warn': summary?.result.sums.subtotal1 < 0 }">
                                        {{ summary?.result.sums.subtotal1 | drCurrency }}
                                    </div>
                                </div>

                                <mat-divider class="mt-3 mb-3"></mat-divider>

                                <calculation-row [label]="summary?.result.trans.car_sales"
                                                 [val_1]="summary?.result.car_sales">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.trans.rental_car_costs"
                                                 [val_1]="summary?.result.rental_car_costs">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.trans.downtime_costs"
                                                 [val_1]="summary?.result.downtime_costs">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.trans.registration_costs"
                                                 [val_1]="summary?.result.registration_costs">
                                </calculation-row>

                                <calculation-row [label]="summary?.result.trans.towing_costs"
                                                 [val_1]="summary?.result.towing_costs">
                                </calculation-row>
                            </div>

                            <div class="col-sm-2">

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-4">

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ summary?.result.trans.leasing_transfer_costs | translate }}</mat-label>
                            <input id="{{idPrefix}}{{summary?.result.trans.leasing_transfer_costs}}"
                                   type="text" matInput currency
                                   [(ngModel)]="summary?.result.leasing_transfer_costs"
                                   (blur)="patchAndUpdate('result.leasing_transfer_costs')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ summary?.result.trans.salvage_potential | translate }}</mat-label>
                            <input id="{{idPrefix}}{{summary?.result.trans.salvage_potential}}"
                                   type="text" matInput currency
                                   [(ngModel)]="summary?.result.salvage_potential"
                                   (blur)="patchAndUpdate('result.salvage_potential')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ summary?.result.trans.car_sales | translate }}</mat-label>
                            <input id="{{idPrefix}}{{summary?.result.trans.car_sales}}"
                                   type="text" matInput currency
                                   [(ngModel)]="summary?.result.car_sales"
                                   (blur)="patchAndUpdate('result.car_sales')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ summary?.result.trans.rental_car_costs | translate }} {{ summary?.result.trans.rental_car_costs_group_price | translate : { rental_car_group: summary?.result.rental_car_group || '--', rental_car_gross: (summary?.result.rental_car_gross ? (summary.result.rental_car_gross | drCurrency) : '-- ' + currency.currency_display_name) } }}</mat-label>
                            <input id="{{idPrefix}}{{summary?.result.trans.rental_car_costs}}"
                                   type="text" matInput currency
                                   [(ngModel)]="summary?.result.rental_car_costs"
                                   (blur)="patchAndUpdate('result.rental_car_costs')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ summary?.result.trans.downtime_costs | translate }} {{ summary?.result.trans.downtime_costs_group_price | translate : { downtime_group: summary?.result.downtime_group || '--', downtime_gross: (summary?.result.downtime_gross ? (summary.result.downtime_gross | drCurrency) : '-- ' + currency.currency_display_name) } }}</mat-label>
                            <input id="{{idPrefix}}{{summary?.result.trans.downtime_costs}}"
                                   type="text" matInput currency
                                   [(ngModel)]="summary?.result.downtime_costs"
                                   (blur)="patchAndUpdate('result.downtime_costs')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ summary?.result.trans.registration_costs | translate }}</mat-label>
                            <input id="{{idPrefix}}{{summary?.result.trans.registration_costs}}"
                                   type="text" matInput currency
                                   [(ngModel)]="summary?.result.registration_costs"
                                   (blur)="patchAndUpdate('result.registration_costs')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

                <div class="row no-gutters">
                    <div class="col-10">
                        <mat-form-field class="full-width">
                            <mat-label>{{ summary?.result.trans.towing_costs | translate }}</mat-label>
                            <input id="{{idPrefix}}{{summary?.result.trans.towing_costs}}"
                                   type="text" matInput currency
                                   [(ngModel)]="summary?.result.towing_costs"
                                   (blur)="patchAndUpdate('result.towing_costs')"
                                   [disabled]="disabled">
                        </mat-form-field>
                    </div>

                    <div class="col-2 align-self-center pl-4">
                        {{ currency.currency_display_name }}
                    </div>
                </div>

            </div>
        </div>
    </mat-tab>


    <!-- PAYMENTS  -->
    <mat-tab id="{{idPrefix}}tab.payments" label="{{ 'detailed_processing.summary.title.payments' | translate }}">
        
        <case-lawyer-payment [idPrefix]="idPrefix"
                             [caseId]="caseId"
                             [readonly]="true">
        </case-lawyer-payment>

    </mat-tab>

</mat-tab-group>

<mat-card class="mb-4">
    <mat-card-content>

        <div class="row no-gutters">
            <div class="col-xs-12 col-sm-4">
                <mat-form-field #mffResultType class="full-width">
                    <mat-label>{{ summary?.decision.trans.decision | translate }}</mat-label>
                    <mat-select id="{{idPrefix}}{{summary?.decision.trans.decision}}"
                                [(ngModel)]="summary?.decision.decision"
                                (ngModelChange)="patchAndUpdate('decision.decision')"
                                [disabled]="disabled">
                        <mat-option *ngFor="let decision of decisions; let idx = index"
                                    id="{{idPrefix}}{{summary?.decision.trans.decision}}.item_{{idx}}"
                                    [value]="decision">
                            {{ decision }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row no-gutters">
            <div class="col-sm-12">
                <mat-form-field class="full-width">
                    <mat-label>{{ summary?.decision.trans.comment | translate }}</mat-label>
                    <textarea id="{{idPrefix}}{{summary?.decision.trans.comment}}"
                              matInput
                              rows="6"
                              [(ngModel)]="summary?.decision.comment"
                              (blur)="patchAndUpdate('decision.comment')"
                              [disabled]="disabled">
                </textarea>
                </mat-form-field>
            </div>
        </div>

    </mat-card-content>
</mat-card>
